import { createApp } from "vue";
import DoorPrice from "./DoorPrice.vue";

const app1 = createApp({});
app1.component('door-price', DoorPrice);
app1.mount('[data-vue-root="door-price"]');

const app2 = createApp({});
app2.component('door-price-mobile', DoorPrice);
app2.mount('[data-vue-root="door-price-mobile"]');
